import { useParams } from 'react-router-dom';
import './Gallery.css';
import useGalleryInteractions from './hooks/useGalleryInteractions';
import GalleryView from './GalleryView';
import { createGlobalStyle } from 'styled-components';
import { useCallback, useMemo, useState } from 'react';
import GalleryShareContext from './GalleryShareContext';
import ShareModal from './ShareModal';

interface DefaultThemeProps {
    foregroundColor?: string;
    backgroundColor?: string;
    headerBackgroundColor?: string;
    headerForegroundColor?: string;
}
const GlobalStyle = createGlobalStyle`
body {
        color: ${({ foregroundColor }: DefaultThemeProps) =>
            foregroundColor || '#000'};
        background-color: ${({ backgroundColor }: DefaultThemeProps) =>
            backgroundColor || '#FFF'};;
}

.Fullscreen-modal {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;

}

.Share-form input {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};
    border-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    border-style:solid;
    font-family: 'Roboto', sans-serif;
}

.Share-form .Link-button {
    background-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.SB-Modal {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.Gallery-cell.expanded {
color: ${({ foregroundColor }: DefaultThemeProps) => foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.Gallery-cell.expanded > .options {
color: ${({ foregroundColor }: DefaultThemeProps) => foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.cta-button {
    background-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};
    }

.Gallery-header {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || '#000'};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.Gallery-name {
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.cta-container {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};
    }

.Find-your-own-photos-banner {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || '#000'};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.Media-container {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'}; 
}

.video-js {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'} !important; 
}

`;

export default function Gallery() {
    const { slug } = useParams();
    const {
        gallery,
        isLoading,
        photos,
        delayed,
        expandedIndex,
        setExpandedIndex,
        swipeHandlers,
        loadedPhotos,
        getNewPage,
    } = useGalleryInteractions(String(slug));

    const [showShareModal, setShowShareModal] = useState(false);
    const [shareIdentifiers, setShareIdentifiers] = useState<string[]>([]);
    const onShareButtonClick = useCallback((shareIdentifier: string) => {
        setShareIdentifiers([shareIdentifier]);
        setTimeout(() => {
            setShowShareModal(true);
        }, 50);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const context = useMemo(
        () => ({
            setShowShareModal: onShareButtonClick,
            setExpandedIndex,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    if (!gallery && !isLoading) {
        return (
            <div>
                <h3>gallery not found...</h3>
            </div>
        );
    }

    return (
        <GalleryShareContext.Provider value={context}>
            <div className="Gallery-view">
                <GlobalStyle
                    foregroundColor={gallery?.foregroundColor}
                    backgroundColor={gallery?.backgroundColor}
                    headerBackgroundColor={gallery?.headerBackgroundColor}
                    headerForegroundColor={gallery?.headerForegroundColor}
                />
                <GalleryView
                    {...{
                        gallery,
                        isLoading,
                        photos,
                        delayed,
                        expandedIndex,
                        setExpandedIndex,
                        swipeHandlers,
                        loadedPhotos,
                        getNewPage,
                        galleryId: gallery?.id || 0,
                    }}
                />
                {gallery && showShareModal && (
                    <ShareModal
                        {...{
                            gallery,
                            shareIdentifiers,
                            setShowShareModal,
                        }}
                    />
                )}
            </div>
        </GalleryShareContext.Provider>
    );
}
